export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14777.a37da893.jpg";